import React from "react";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import Marketplace from "../components/Marketplace/Marketplace";

function MarketplacePage() {
  return (
    <div>
      <TopBar />
      <div className="pt-[3.3rem]">
        <Marketplace />
      </div>
      <Footerr />
    </div>
  );
}

export default MarketplacePage;
